import { whooshPrimitives } from "./primitives";

export type WhooshSurfaceColorTokens = {
  "surface-primary": string;
  "surface-secondary": string;
  "surface-dividers": string;
  "surface-overlay": string;
  "surface-inverse": string;

  "surface-main-primary-subtlest": string;
  "surface-main-primary-subtler": string;
  "surface-main-primary-subtle": string;
  "surface-main-primary-neutral": string;

  "surface-main-secondary-subtlest": string;
  "surface-main-secondary-subtler": string;
  "surface-main-secondary-subtle": string;
  "surface-main-secondary-neutral": string;

  "surface-accent-blue-subtlest": string;
  "surface-accent-blue-subtler": string;
  "surface-accent-blue-subtle": string;

  "surface-accent-purple-subtlest": string;
  "surface-accent-purple-subtler": string;
  "surface-accent-purple-subtle": string;

  "surface-accent-pink-subtlest": string;
  "surface-accent-pink-subtler": string;
  "surface-accent-pink-subtle": string;

  "surface-status-success-subtlest": string;
  "surface-status-success-subtler": string;
  "surface-status-success-subtle": string;
  "surface-status-warning-700": string;
  "surface-status-warning-subtlest": string;
  "surface-status-warning-subtler": string;
  "surface-status-warning-subtle": string;
  "surface-status-error-subtlest": string;
  "surface-status-error-subtler": string;
  "surface-status-error-subtle": string;

  "component/tee-sheet/slot/surface/today": string;
  "component/tee-sheet/slot/surface/future": string;

  "component/tee-sheet/booking/surface/today": string;
  "component/tee-sheet/booking/surface/future": string;
};

export const whooshSurfaceColors: WhooshSurfaceColorTokens = {
  "surface-primary": whooshPrimitives.grayscale[0],
  "surface-secondary": whooshPrimitives.grayscale[100],
  "surface-dividers": whooshPrimitives.grayscale[500],
  "surface-overlay": whooshPrimitives.grayscale[1000],
  "surface-inverse": whooshPrimitives.grayscale[1000],

  "surface-main-primary-subtlest": whooshPrimitives.main.primary[100],
  "surface-main-primary-subtler": whooshPrimitives.main.primary[200],
  "surface-main-primary-subtle": whooshPrimitives.main.primary[300],
  "surface-main-primary-neutral": whooshPrimitives.main.primary[500],

  "surface-main-secondary-subtlest": whooshPrimitives.main.secondary[100],
  "surface-main-secondary-subtler": whooshPrimitives.main.secondary[200],
  "surface-main-secondary-subtle": whooshPrimitives.main.secondary[300],
  "surface-main-secondary-neutral": whooshPrimitives.main.secondary[500],

  "surface-accent-blue-subtlest": whooshPrimitives.accent.blue[100],
  "surface-accent-blue-subtler": whooshPrimitives.accent.blue[200],
  "surface-accent-blue-subtle": whooshPrimitives.accent.blue[300],

  "surface-accent-purple-subtlest": whooshPrimitives.accent.purple[100],
  "surface-accent-purple-subtler": whooshPrimitives.accent.purple[200],
  "surface-accent-purple-subtle": whooshPrimitives.accent.purple[300],

  "surface-accent-pink-subtlest": whooshPrimitives.accent.pink[100],
  "surface-accent-pink-subtler": whooshPrimitives.accent.pink[200],
  "surface-accent-pink-subtle": whooshPrimitives.accent.pink[300],

  "surface-status-success-subtlest": whooshPrimitives.status.success[100],
  "surface-status-success-subtler": whooshPrimitives.status.success[200],
  "surface-status-success-subtle": whooshPrimitives.status.success[300],
  "surface-status-warning-subtlest": whooshPrimitives.status.warning[100],
  "surface-status-warning-subtler": whooshPrimitives.status.warning[200],
  "surface-status-warning-subtle": whooshPrimitives.status.warning[300],
  "surface-status-warning-700": whooshPrimitives.status.warning[700],
  "surface-status-error-subtlest": whooshPrimitives.status.error[100],
  "surface-status-error-subtler": whooshPrimitives.status.error[200],
  "surface-status-error-subtle": whooshPrimitives.status.error[300],

  "component/tee-sheet/slot/surface/today": whooshPrimitives.grayscale[0],
  "component/tee-sheet/slot/surface/future": whooshPrimitives.grayscale[100],

  "component/tee-sheet/booking/surface/today": whooshPrimitives.grayscale[100],
  "component/tee-sheet/booking/surface/future": whooshPrimitives.grayscale[200],
};
